import { BaselayerSelector } from './BaseLayerSelector'
import EventEmitter from 'eventemitter3'
import * as Cesium from 'cesium'
import { CESIUM_ION_KEY } from '@/config'
import { addBridge, addTerrain, createViewer, setHomeView } from '.'
import { CameraController } from './mod/CameraController'
import { LayerManager } from './mod/LayerManager'
import { isDev } from '../utils'

let readyHandle: ((value: CesiumObj) => void) | undefined = undefined
export class CesiumObj extends EventEmitter<'initialized'> {
  private static instance?: CesiumObj
  private static isReady = new Promise<CesiumObj>((res) => {
    readyHandle = (instance: CesiumObj) => {
      res(instance)
    }
  })
  static async getInstance(): Promise<CesiumObj> {
    if (!CesiumObj.instance) {
      return await CesiumObj.isReady
    }
    return CesiumObj.instance
  }
  static bindContainer(dom: HTMLDivElement) {
    if (!readyHandle) throw new Error('cesium初始化失败')
    CesiumObj.destroy()
    Cesium.Ion.defaultAccessToken = CESIUM_ION_KEY

    CesiumObj.instance = new CesiumObj(dom)
    readyHandle(CesiumObj.instance)
  }

  static destroy() {
    CesiumObj.instance?.viewer.destroy()
    CesiumObj.instance?.removeAllListeners()
    CesiumObj.instance = undefined
    CesiumObj.isReady = new Promise<CesiumObj>((res) => {
      readyHandle = (instance: CesiumObj) => {
        res(instance)
      }
    })
  }

  viewer
  cameraController
  layerManager
  baselayerSelector
  private constructor(dom: HTMLDivElement) {
    super()
    this.viewer = createViewer(dom)
    this.baselayerSelector = new BaselayerSelector(this.viewer)
    addTerrain(this.viewer)
    // addS57(this.viewer)
    addBridge(this.viewer)
    setHomeView(this.viewer)
    this.cameraController = new CameraController(this.viewer)
    this.layerManager = new LayerManager(this)
    if (isDev) {
      // @ts-ignore
      window.cesiumobj = this
      // @ts-ignore
      window.Cesium = Cesium
      // eslint-disable-next-line no-console
      console.log(
        '%ccesiumobj已挂载到window\nCesium已挂载到window',
        'color: black; font-size: 20px; font-weight: bold;background:skyblue;padding:0px 6px'
      )
    }
  }
}
